import { render, staticRenderFns } from "./DesignFormList.vue?vue&type=template&id=4d9d3566&scoped=true&"
import script from "./DesignFormList.vue?vue&type=script&lang=js&"
export * from "./DesignFormList.vue?vue&type=script&lang=js&"
import style0 from "./DesignFormList.vue?vue&type=style&index=0&id=4d9d3566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9d3566",
  null
  
)

export default component.exports